module.exports = {
  primary: '#514CF1',
  primaryOffset: '#FF7272',
  dark: '#2B2C2E',
  darkOffset: '#FF7272',
  medium: '#61718C',
  mediumOffset: '#FF7272',
  light: '#C8D7F1',
  lightOffset: '#afc9f5',
  accent: '#FF7272',

  black: '#000000',
  white: '#FFFFFF',
  offWhite: '#e8e8e8',
  whiteBackground: 'rgba(255, 255, 255, 0.4)',
  clear: '#00000000',

  textDark: '#2B2C2E',
  textLight: '#8696b4',
  textError: '#B00000',

  alert: '#F00000',

  active: '#00D100',
  away: '#FFFF00',
  busy: '#F00000',
  offline: '#808080',

  modalBackground: '#888888CC',
  buttonBackground: 'rgba(140, 140, 140, 0.3)',

  sexGender: {
    female: '#FF7272',
    male: '#72c2ff',
    trans: '#8767d4',
    unkown: '#808080',
  },

  burn: {
    flame: '#B00000',
    heat: '#B00000',
    scald: '#B00000',
    scaldOil: '#2B2C2E',
    chemical: '#008b02',
    electrical: '#004dcf',
  },

  severity: {
    one: '#f5a623',
    two: '#db3e00',
    three: '#B00000',
    four: '#5d0000',
  }
};